// extracted by mini-css-extract-plugin
export default {"overlay":"MiniCalculatorBox_overlay__RulRV","calculator":"MiniCalculatorBox_calculator__dlO8Z","hideButton":"MiniCalculatorBox_hideButton__w-dzJ"};